/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import {createAsyncThunk} from "@reduxjs/toolkit";
import {apiInstance} from "../../Apis/Axios";
import {MATERIAL_REQUEST_SERVICE} from "../EndPoints";

export const GetMaterialRequestById = createAsyncThunk(
    'materialRequestService/getMaterialRequestById',
    async (id) => {
        const result = await apiInstance
            .get(`${MATERIAL_REQUEST_SERVICE.getMaterialRequestById}${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const GetMaterialRequestQrCode = createAsyncThunk(
    'materialRequestService/getMaterialRequestQrCode',
    async (id) => {
        const result = await apiInstance
            .get(`${MATERIAL_REQUEST_SERVICE.getMaterialRequestQrCode}${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const CreateMaterialRequest = createAsyncThunk(
    'materialRequestService/createMaterialRequest',
    async (params) => {
        const response = await apiInstance.post(`${MATERIAL_REQUEST_SERVICE.createMaterialRequest}`, params
        ).then(function (response) {
            return response
        }).catch(function (error) {
            return error.response
        })
        const { data, status } = response

        return { data, status }
    }
);

export const ApprovalMaterialRequest = createAsyncThunk(
    'materialRequestService/approvalMaterialRequest',
    async (params) => {
        const response = await apiInstance.put(`${MATERIAL_REQUEST_SERVICE.approvalMaterialRequest}`, params
        ).then(function (response) {
            return response
        }).catch(function (error) {
            return error.response
        })
        const { data, status } = response

        return { data, status }
    }
);

export const DispatchMaterialRequest = createAsyncThunk(
    'materialRequestService/dispatchMaterialRequest',
    async (params) => {
        const response = await apiInstance.put(`${MATERIAL_REQUEST_SERVICE.dispatchMaterialRequest}`, params
        ).then(function (response) {
            return response
        }).catch(function (error) {
            return error.response
        })
        const { data, status } = response

        return { data, status }
    }
);

export const CreateMaterialRequestItemEvidence = createAsyncThunk(
    'materialRequestService/createMaterialRequestItemEvidence',
    async (params) => {
        const response = await apiInstance.post(`${MATERIAL_REQUEST_SERVICE.createMaterialRequestItemEvidence}`, params
        ).then(function (response) {
            return response
        }).catch(function (error) {
            return error.response
        })
        const { data, status } = response

        return { data, status }
    }
);

export const UpdateMaterialRequestItemEvidence = createAsyncThunk(
    'materialRequestService/updateMaterialRequestItemEvidence',
    async (params) => {
        const response = await apiInstance.post(`${MATERIAL_REQUEST_SERVICE.updateMaterialRequestItemEvidence}`, params
        ).then(function (response) {
            return response
        }).catch(function (error) {
            return error.response
        })
        const { data, status } = response

        return { data, status }
    }
);
